// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useQuery, { type QueryArgs } from '../../useQuery';
import { TournamentsQueryDocument, type TournamentsQuery, type TournamentsQueryVariables } from './TournamentsQuery';

export async function getTournamentsQueryClient(variables: TournamentsQueryVariables) {
  return fetchGraphqlClient<TournamentsQuery, TournamentsQueryVariables>(TournamentsQueryDocument, "TournamentsQuery", { variables });
}
export const useTournamentsQuery = (...args: QueryArgs<TournamentsQueryVariables>) => useQuery<TournamentsQuery, TournamentsQueryVariables>(getTournamentsQueryClient, ...args);